import { Chance } from 'chance';

const chance = new Chance();
type AtLeastOneKey<T, U = { [K in keyof T]: Pick<T, K> }> = Partial<T> & U[keyof U];

export function isEyes() {
  return typeof window !== 'undefined' && window.location.search.includes('eyes-storybook=true');
}

export function pickset<T>(arr: T[], size?: number) {
  if (isEyes()) {
    return arr.slice(0, size);
  }
  return chance.pickset(arr, size);
}

export function pickone<T>(arr: T[], anotherOne?: boolean) {
  if (isEyes()) {
    return arr[anotherOne ? 1 : 0];
  }

  return chance.pickone(arr);
}

export function natural(config?: Chance.Options): number {
  if (isEyes()) {
    return config?.max ?? 0;
  }
  return chance.natural(config);
}

export function integer(config?: AtLeastOneKey<Chance.IntegerOptions>) {
  if (isEyes()) {
    return 3124353;
  }
  return chance.integer(config);
}

export function floating(config?: Chance.Options) {
  if (isEyes()) {
    return 432.35;
  }
  return chance.floating(config);
}

export function word(opts?: AtLeastOneKey<Chance.WordOptions>) {
  if (isEyes()) {
    return 'potato';
  }
  return chance.word(opts);
}

export function sentence(config?: AtLeastOneKey<Chance.SentenceOptions>) {
  if (isEyes()) {
    return config?.words ? 'Mudkips '.repeat(config.words) : 'Mudkips';
  }
  return chance.sentence(config);
}

export function paragraph(opts?) {
  if (isEyes()) {
    return 'Lorem ipsum dolor sit amet';
  }
  return chance.paragraph(opts);
}

export function url(opts?: AtLeastOneKey<Chance.UrlOptions>) {
  if (isEyes()) {
    return 'http://www.deviantart.com/';
  }
  return chance.url(opts);
}

export function bool(opts?) {
  if (isEyes()) {
    return false;
  }
  return chance.bool(opts);
}

export function date(opts?: Chance.DateOptions) {
  if (isEyes()) {
    return new Date('2019-03-08');
  }
  return chance.date(opts);
}

export function d20() {
  if (isEyes()) {
    return 14;
  }
  return chance.d20();
}

export function shuffle<T>(arr: T[]) {
  if (isEyes()) {
    return arr.reduceRight((acc, value) => {
      acc.push(value);
      return acc;
    }, []);
  }
  return chance.shuffle(arr);
}

// this one is not random so safe to just forward
export function n<T>(generator: () => T, count: number) {
  return chance.n(generator, count);
}

// ---- time
export function secondsFromNow(seconds: number): Date {
  const now = new Date();
  now.setSeconds(now.getSeconds() + seconds);
  return now;
}

// resisting the urge to try and be clever here and instead using multiple, stupid functions
export function minutesFromNow(minutes: number): Date {
  const now = new Date();
  now.setMinutes(now.getMinutes() + minutes);
  return now;
}

export function hoursFromNow(hours: number): Date {
  const now = new Date();
  now.setHours(now.getHours() + hours);
  return now;
}

export function daysFromNow(days: number): Date {
  const now = new Date();
  now.setDate(now.getDate() + days);
  return now;
}
